import { render } from "./LogoutConfirmDialog.vue?vue&type=template&id=2f6e42fa&scoped=true"
import script from "./LogoutConfirmDialog.vue?vue&type=script&lang=js"
export * from "./LogoutConfirmDialog.vue?vue&type=script&lang=js"

import "./LogoutConfirmDialog.vue?vue&type=style&index=0&id=2f6e42fa&scoped=true&lang=css"

import exportComponent from "D:\\TDS\\40_製造(M)\\99_電帳法_USE\\Tatsuzin_filemanage\\vue\\tdsvue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f6e42fa"]])

export default __exports__